import React, { createContext, useContext, useReducer, useEffect } from "react";
import reducer from "../reducers/contracts_reducer";

// APIs
import getContracts from "../apis/prod/contracts/get_contracts";
import getContract from "../apis/prod/contracts/get_contract";
import getContractPublic from "../apis/prod/contracts/get_contract_public";

import ParcisionCookies from "~/utils/Cookies";
// import { useWalletContext } from "./wallet_context";

// ACTIONS
import {
  GET_CONTRACTS_BEGIN,
  GET_CONTRACTS_SUCCESS,
  GET_CONTRACTS_ERROR,
  GET_CONTRACT_BEGIN,
  GET_CONTRACT_SUCCESS,
  GET_CONTRACT_ERROR,
} from "~/actions/contracts";

// DEPENDENT PROVIDERS
import { useFilterContractsContext } from "./filter_contracts_context";
import { sentryWrappedException } from "~/utils/Utils";

interface InitialContractsState {
  contractsLoading: boolean;
  contractsError: boolean;
  contracts: string[];
  contracts_avaliable: {
    contract: unknown;
    symbol: string[];
    sector: string[];
    industry: string[];
    style: string[];
    // TODO: what should these values be? - ch
    mingoptin: number;
    maxgoptin: number;
    mingprize: number;
    maxgprize: number;
  };
  contractLoading: boolean;
  contractError: boolean;
  contract: unknown;
}

const initialState: InitialContractsState = {
  contractsLoading: true,
  contractsError: false,
  contracts: [],
  contracts_avaliable: {
    contract: null,
    symbol: [],
    sector: [],
    industry: [],
    style: [],
    // TODO: what should these values be? - ch
    mingoptin: 0,
    maxgoptin: 0,
    mingprize: 0,
    maxgprize: 0,
  },
  contractLoading: true,
  contractError: false,
  contract: [],
};
const ContractsContext = createContext<InitialContractsState>(initialState);

export function ContractsProvider({ children }: React.PropsWithChildren) {
  const { refreshContracts, tokensContracts, pageNumberContracts, sortContracts, filterContracts } =
    useFilterContractsContext(); // LOAD FILTER SORT PARAMETERS

  const [state, dispatch] = useReducer(reducer, initialState);

  const getContractsCONTEXT = async () => {
    dispatch({ type: GET_CONTRACTS_BEGIN });
    try {
      const res = await getContracts(pageNumberContracts, sortContracts, filterContracts); // address + pid from AWS token on server side

      dispatch({ type: GET_CONTRACTS_SUCCESS, payload: { contracts: res.nodes, avaliable: res.avaliable } });
    } catch (error) {
      sentryWrappedException(error);
      dispatch({ type: GET_CONTRACTS_ERROR });
      throw error;
    }
  };

  const getContractCONTEXT = async (cid: number) => {
    dispatch({ type: GET_CONTRACT_BEGIN });
    try {
      const res = await getContract(cid); // address + pid from AWS token on server side

      dispatch({ type: GET_CONTRACT_SUCCESS, payload: { contract: res } });
    } catch (error) {
      sentryWrappedException(error);
      dispatch({ type: GET_CONTRACT_ERROR });
      throw error;
    }
  };

  const getContractPublicCONTEXT = async (cid: number) => {
    dispatch({ type: GET_CONTRACT_BEGIN });
    try {
      const res = await getContractPublic(cid); // address + pid from AWS token on server side

      dispatch({ type: GET_CONTRACT_SUCCESS, payload: { contract: res } });
    } catch (error) {
      sentryWrappedException(error);
      dispatch({ type: GET_CONTRACT_ERROR });
      throw error;
    }
  };

  // if filters, pagenumber, or sort updates then get the new products list
  useEffect(() => {
    const init = async () => {
      if (ParcisionCookies.check("auth0_sessionToken")) {
        await getContractsCONTEXT();
      }
    };
    init().catch(sentryWrappedException);
  }, [filterContracts, pageNumberContracts, sortContracts, tokensContracts, refreshContracts]);

  return (
    <ContractsContext.Provider
      value={{ ...state, dispatch, getContractsCONTEXT, getContractCONTEXT, getContractPublicCONTEXT }}
    >
      {children}
    </ContractsContext.Provider>
  );
}

// make sure use
export const useContractsContext = () => useContext(ContractsContext);
